import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { getSettings } from "./api";

const SettingsContext = createContext({});

export function SettingsProvider({ children }) {
  const { data } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  return <SettingsContext.Provider value={data || {}}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
